export const clearchoice = {
	PAGE_THEME_ENABLED: false,
};
